import { render, staticRenderFns } from "./VUserManagerTablePagination.vue?vue&type=template&id=71371ce4"
import script from "./VUserManagerTablePagination.vue?vue&type=script&lang=js"
export * from "./VUserManagerTablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports